@if (open) {
  <div class="debug-container mat-elevation-z5">
    <mat-icon class="close-icon" (click)="open = false">keyboard_arrow_right</mat-icon>
    <h4>Debug-Menu <button mat-button color="accent" (click)="debugService.disableDebug()">Disable Debug</button></h4>
    <mat-tab-group dynamicHeight>
      <mat-tab label="CD">
        <ng-template matTabContent>
          <dt-change-detection-info></dt-change-detection-info>
        </ng-template>
      </mat-tab>
      <mat-tab label="Progress">
        <div>Current Progress: {{ currentProgressService.currentProgress | json }}</div>
        <div>Active Step: {{ currentProgressService.activeStep | async | json }}</div>
      </mat-tab>
      <mat-tab label="Navi State">
        <div [formGroup]="modeRadioGroup">
          Navi-Mode:
          <mat-radio-group formControlName="currentMode" (change)="valueChange($event)">
            <mat-radio-button value="educational">Educational</mat-radio-button>
            <mat-radio-button value="starter">Starter</mat-radio-button>
            <mat-radio-button value="professional">Professional</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          Environment:
          <mat-radio-group [(ngModel)]="environmentType">
            <mat-radio-button value="development">Development</mat-radio-button>
            <mat-radio-button value="preview">Preview</mat-radio-button>
            <mat-radio-button value="nightly">Nightly</mat-radio-button>
            <mat-radio-button value="production">Production</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <button mat-raised-button color="accent" (click)="showNightlyWarning()">Show Nightly warning</button>
        </div>
        <div>
          <button mat-raised-button color="accent" (click)="dummyUpdateState('no-update')">Version aktuell</button>
          <button mat-raised-button color="accent" (click)="dummyUpdateState('loading-update')">Update wird geladen</button>
          <button mat-raised-button color="accent" (click)="dummyUpdateState('update-ready')">Update verfügbar</button>
        </div>
      </mat-tab>
      <mat-tab label="Errors">
        <button mat-button (click)="crash()">Crash</button>
      </mat-tab>
      <mat-tab label="Project">
        <div>Time tracking active: {{ timeTrackingActive }}</div>
        <button mat-button (click)="manuallyLogTimeRecordings()">Log current time recordings</button>
        <div>Save state: {{ autoSaveService.saveState$ | async }}</div>
        <div>Last Decision Data change event: {{ lastDecisionDataChangeEventTime$ | async | date: 'medium' }}</div>
      </mat-tab>
    </mat-tab-group>
    <div class="component-debug">
      @for (fleetingTemplate of fleetingDebugTemplates; track fleetingTemplate) {
        <ng-container *ngTemplateOutlet="fleetingTemplate.template"></ng-container>
      }
    </div>
  </div>
} @else {
  <div class="hidden-container">
    <mat-icon (click)="open = true">code</mat-icon>
  </div>
}

<ng-template #button>
  <div class="hidden-container">
    <mat-icon (click)="open = true">code</mat-icon>
  </div>
</ng-template>
